import type { AuthSession } from '../features/auth/types'
import { ClientTypes, UserTypes } from '../types/authorization'

export type InitDetailScope = 'client' | 'user'

export type InitDetailRequest = {
  scope: InitDetailScope
  endpoint: 'client/ui/detail/initialise' | 'user/ui/detail/initialise'
  clientId: string
  userId: string
}

const ZERO_GUID = '00000000-0000-0000-0000-000000000000'

function getEffectiveUserType(session: AuthSession | null) {
  if (!session) return undefined
  if (session.currentUserId === ZERO_GUID) return UserTypes.UnregisteredUser
  return session.currentUserTypeId
}

export function resolveInitDetailRequest(session: AuthSession | null): InitDetailRequest | null {
  if (!session) return null

  const clientId = session.currentClientId || ''
  const userId = session.currentUserId || ''
  const userType = getEffectiveUserType(session)
  const clientType = session.currentClientTypeId

  if (userType === UserTypes.User) {
    return {
      scope: 'user',
      endpoint: 'user/ui/detail/initialise',
      clientId,
      userId,
    }
  }

  if (userType === UserTypes.ClientUser && clientType !== ClientTypes.Advisor) {
    return {
      scope: 'user',
      endpoint: 'user/ui/detail/initialise',
      clientId,
      userId,
    }
  }

  return {
    scope: 'client',
    endpoint: 'client/ui/detail/initialise',
    clientId,
    userId,
  }
}
